const featureLogsTransformer = response => {
  return response.map(e => {
    let fixedFeature = []
    let additionalFeature = []
    e.activitiesObj.forEach(feature => {
      if (feature.Fixed == 0) {
        additionalFeature?.push({ ...feature })
      } else if (feature.Fixed == 1) {
        fixedFeature?.push({ ...feature })
      }
    })
    return { ...e, fixedFeature: fixedFeature, additionalFeature: additionalFeature }
  })
}
export default featureLogsTransformer
